import React from 'react';

const FacebookFeeds = () => {
  return <div>Facebook Feeds</div>;
};

export default FacebookFeeds;
